import moment from 'moment';

export const formatAllRequests = (requests) => {
  let { stockData, avicData, pirData } = requests;

  if ((stockData || []).length > 0) {
    stockData = stockData.map((request) => {
      return {
        request_id: request.request_id,
        material: request.material,
        material_description: request.material_description,
        type: 'Stock Price Extension',
        sales_org: request.sales_org,
        country: undefined,
        requester: request?.updatedByUser?.name,
        submitted_on: request.updatedAt
          ? moment(request.updatedAt).format('YYYY-MM-DD')
          : undefined,
      };
    });
  }

  if ((avicData || []).length > 0) {
    avicData = avicData.map((request) => {
      return {
        request_id: request.request_id,
        material: request.material,
        material_description: request.material_description,
        type: 'AVIC Extension',
        sales_org: request.sales_org,
        country: undefined,
        requester: request?.updatedByUser?.name,
        submitted_on: request.completed_on
          ? moment(request.completed_on).format('YYYY-MM-DD')
          : undefined,
      };
    });
  }

  if ((pirData || []).length > 0) {
    pirData = pirData.map((request) => {
      return {
        request_id: request.request_id,
        material: request.material,
        material_description: request.material_description,
        type: 'PIR Extension',
        sales_org: request.sales_org,
        country: request.country,
        requester: request?.submittedByUser?.name,
        submitted_on: request.updated_at
          ? moment(request.updated_at).format('YYYY-MM-DD')
          : undefined,
      };
    });
  }

  return [...stockData, ...avicData, ...pirData];
};
